// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__LS+ok","chip_label":"styles_chip_label__5FyNl","chip_sublabel":"styles_chip_sublabel__FHaxT","chip_icon":"styles_chip_icon__298DL"};